import { MarketNightlyRefreshProviderSet } from "@app/operations/market-nightly-refresh/interfaces";
import { isProviderSetIgnored } from "@app/operations/market-nightly-refresh/MarketNightlyRefreshFilters";
import { copyToClipboardWithToast } from "@app/operations/market-nightly-refresh/utils";
import { NewActionMenu } from "@app/shared/action-menu";
import { NewActionMenuItem } from "@app/shared/action-menu/NewActionMenuItem";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import RoleRestricted from "@app/user/RoleRestricted";
import Roles from "@app/user/roles";
import { FC } from "react";

interface ProviderSetRowActionMenuProps {
  provider: MarketNightlyRefreshProviderSet;
  onToggleStage: (provider: MarketNightlyRefreshProviderSet) => void;
}

export const ProviderSetRowActionMenu: FC<ProviderSetRowActionMenuProps> = ({ provider, onToggleStage }) => (
  <NewActionMenu
    testId={`mnr-row-actions--${provider.providerSetId}`}
    buttonText={<QesIcon iconName={QesIcons.DotsVertical} description="Actions" />}
    buttonClassNames="p-0 text-dark btn-icon btn-sm"
    closeOnClick={true}
    hideArrow={true}
    fixMenu={true}
    fixedMenuOffset={{ x: -210, y: 50 }}
  >
    <RoleRestricted allowedRoles={[Roles.OPERATIONS_ADMIN]}>
      <NewActionMenuItem
        testId={`mnr-row-actions__toggle--${provider.providerSetId}`}
        display={isProviderSetIgnored(provider) ? "Include" : "Exclude"}
        onClick={() => onToggleStage(provider)}
      />
    </RoleRestricted>
    <NewActionMenuItem
      testId={`mnr-row-actions__copy-id--${provider.providerSetId}`}
      display="Copy Provider Set ID"
      onClick={() => copyToClipboardWithToast(String(provider.providerSetId), "Provider Set ID")}
    />
  </NewActionMenu>
);
